@switch (pickupType) {
  @case ('own_activity') {
    <div class="pickup-for-own">
      <div class="pickup" (click)="clickPickup()">
        <img class="pickup-icon" src="assets/images/icons/pickup-active.svg" />
        <span class="spen-util-link">{{ this.getPickupTitle() }}</span>
        <i class="{{ getClassIconArrow() }}"></i>
      </div>
      @if (display) {
        <div class="info">
          <div class="reason preserve-line-break" appConvertLink>{{ this.getPickupReason() }}</div>
          @if (pickupExpired()) {
            <span class="space-name">{{ pickup.space.name }}</span>
          } @else {
            <span routerLink="/spaces/student/{{ pickup?.space.id }}" class="space-name spen-util-link">{{ pickup.space.name }}</span>
          }
          @if (pickup.is_anonymous) {
            <p>匿名</p>
          }
          <div class="pickup-time">ピックアップ期間：{{ pickup.end_time | date: 'yyyy/MM/dd' }} まで</div>
        </div>
      }
    </div>
  }
  @case ('public_activity') {
    <div class="pickup-for-public">
      <div class="pickup" [class.no-reason]="isNoReason" (click)="clickPickup()">
        <img class="pickup-icon" src="{{ this.getIconSrc() }}" />
        <span [class.spen-util-link]="!isNoReason">{{ this.getPickupTitle() }}</span>
        @if (!isNoReason) {
          <i class="{{ getClassIconArrow() }}"></i>
        }
      </div>
      @if (display) {
        <div class="reason preserve-line-break" appConvertLink>{{ this.getPickupReason() }}</div>
      }
    </div>
  }
}
